<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs bee-shadow {{ sectionclass }}">
  <app-loader [showLoader]=showLoad></app-loader>
  <div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom">
    <div class="o-stack__cell">
      <h5 class="card-title">{{sectiontitle}}</h5>
      <span class="datatable-icon" *ngIf="hasData && tableConfig.enableDownload">
        <a href="javascript:void(0)" class="datatable_download_icon" (click)="downloadCSV($event)" target="_blank">
            <i class="fa fa-download" aria-hidden="true"></i>
        </a>
    </span>
    </div>
  </div>
  <div class="analytics-portlet-content">
    <ngx-datatable class="material" [columns]="dataTableObj.columns" [rows]="geofenceAppData" [scrollbarV]="true"
      [sortType]="'single'" [cssClasses]="cssClasses" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="0"
      [rowHeight]="55" [reorderable]="reorderable">
      <ngx-datatable-column name={{column.name}} prop="{{column.columnKey}}" class="{{column.cellClass}} r4-datatable-column" *ngFor="let column of dataTableObj.columns; let i=index;"
        [sortable]="true">
        <ngx-datatable-column name="{{column.name}}" prop="{{column.prop}}" [resizeable]="false" [sortable]="true"
          [cellClass]="column.cellClass" [headerClass]="column.headerClass" [comparator]="column.comparator">
          <ng-template let-colHeader="column" let-sort="sortFn" ngx-datatable-header-template>
            <span (click)="sort()" class="r4-cursor" *ngIf="!column.columnHasTooltip; else elseBlock">
              {{colHeader.name}}
            </span>
            <ng-template #elseBlock>
              <span class="r4-cursor">
                <span (click)="sort()" appTooltip title="Tooltip" [title]="column.columnTooltip" data-size="big"
                  [options]="tooltipOptions">
                  {{colHeader.name}}
                </span>
              </span>
            </ng-template>
          </ng-template>
        </ngx-datatable-column>
        <ng-template ngx-datatable-cell-template let-value="value" let-rowIndex="rowIndex" let-row="row">
          <div class="r4-datatable-tooltip">
            <span class="r4-cursor">
              <span appTooltip title="Tooltip" [title]="row.appname" data-size="big" [options]="tooltipOptions" *ngIf="column.prop === 'formattedAppName' || column.prop == 'appname'">
                {{row[column.prop]}}
              </span>
            </span>
            <span *ngIf="column.prop !== 'formattedAppName' && column.prop !== 'appname'"> {{row[column.prop]}}</span>
            <div class="progressbar" *ngIf="column.hasProgressBar && row[column.prop] !== '--'">
              <div class="bar primary-color-bg" [ngStyle]="getPercentage(row, column.prop)"></div>
            </div>

          </div>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>
</div>
